import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { hasRole } from "../../../../../../utils/permissions";
import { showErrorAlert } from "../../../../../../helpers/alert";
import { UserRole } from "../../../../../../constants/roles";
import { RootState } from "../../../../../../../setup";
import { CommunityDiscussComments } from "../../../../../community/models/CommunityDiscussComments";
import { useResourceUpload } from "../../../../../../hooks/community/useResourceUpload";
import { LoaderOverlay } from "../../../../../../hooks/loader/LoaderOverlay";
import { CommunityAdminBanModal } from "../../../../../communityAdmin/components/CommunityAdminBanModal";
import { CommunityAdminCommentsWrap } from "../../../../../communityAdmin/components/CommunityAdminCommentsWrap";
import { CommunityInputComment } from "../../../../../community/components/CommunityInputComment";
import { CommunityAdminReviewContent } from "../../../../../communityAdmin/components/CommunityAdminReviewContent";
import { CommunityAdminMedia } from "../../../../../communityAdmin/components/CommunityAdminMedia";
import { useCommunityReview } from "../../../../../../hooks/community/useAdminReview";
import { UserModel } from "../../../../../../modules/auth/models/UserModel";

type Props = {
    id: number;
    onClose: () => void;
}
export const ProfileMemberCommunityDetails = ({ id, onClose }: Props) => {
    const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel;

    useEffect(() => {
        allowed();
    }, []);

    const allowed = () => {
        const _isAdmin = hasRole(user, UserRole.ADMIN)
        if(!_isAdmin) {
            onClose();
            showErrorAlert({ title: 'Access Denied', message: 'You do not have permission to access this page.' });
        }
    }

    const [ban, setBan] = useState<{ id: number, target:  'user' | 'forum', username?: string } | null>(null);
    const { details, error, loading: loadDetails, addComment, deleteComment, toBanUser, toBanForum, deleteResource } = useCommunityReview(id);
    const { files, insertFile, removeFile, processFiles } = useResourceUpload(id);
    const [replySelect, setReplySelect] = useState<CommunityDiscussComments | null>(null);

    useEffect(() => {
        if(!!error)
            onClose();
    }, [error]);

    return (
        <>
        <LoaderOverlay visible={loadDetails} message={'Loading...'} />
        {!!details && !!ban && (
            <CommunityAdminBanModal
                id={ban.id} 
                target={ban.target} 
                username={ban.username}
                onClose={() => setBan(null)} 
                onBan={async (target, id, type, reason, duration) => {
                    if(target === 'user')
                        await toBanUser(id, type, duration, reason)
                    else
                        await toBanForum(id, type, duration, reason);
                    setBan(null);
                }} 
            />
        )}
        { !!details && (
            <>
                <div className="admin-community-review__wrapper">
                    <div className="admin-community-review__comments">
                        <div className="w-100 tap-flex-center justify-content-start">
                            <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> onClose()}>
                                Back
                            </div>
                        </div>
                        
                        <h3>{details.type}</h3>

                        <CommunityAdminCommentsWrap 
                            comments={details.comments}
                            onSuspendUser={(c) => setBan({ target: 'user', id: c.authorId, username: c.author })}
                            onDeleteComment={(c) => deleteComment(c.id)}
                        />

                        <CommunityInputComment
                            cleanReply={() => setReplySelect(null)}
                            onSendComment={(value) => addComment(value, replySelect?.id, processFiles)}
                            onAddFile={insertFile}
                            files={files}
                            OnRemoveFile={(f) => removeFile(f.file)}
                        />
                    </div>
                    <div className="admin-community-review__content">
                        <CommunityAdminReviewContent
                            type={details.type}
                            author={details.author}
                            circles={details.circles}
                            content={details.content}
                            topic={details.topic}
                            facilitator={details.facilitator}
                            onSuspendForum={() => setBan({ id, target: "forum", username: details.author.username })}
                        />
                        <CommunityAdminMedia mediafiles={details.mediafiles} onDelete={m => deleteResource(m.id)}/>
                    </div>
                </div>
            </>
        )}
        </>
    )
}